import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Nav, Tab, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../App";
import Banner from "../../../../assets/images/BannerAuditionAdmin.png";
import TableJuryPaginateReuse from "../../../Audition_static/Audition_admin/TableJuryPaginateReuse";
import HeaderTitle from "../../../Audition_static/Auditon-comp/HeaderTitle";
import LoaderPost from "../../../Reuseable/LoaderPost";
import ReUseableSingleRoundTab from "../../../Reuseable/ReUseableSingleRoundTab";

const VideoAssessmentAsPrimaryGroup = ({
  currentSlide,
  slideCount,
  ...props
}) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [videoType, setVideoType] = useState("general");

  const { slug } = useParams();
  const [distributedVideoArray, setDistributedVideoArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeRound, setActiveRound] = React.useState(0);
  const [event, setEvent] = useState({});
  const [auditionRoundInfo, setAuditionRoundInfo] = useState({});
  const [percentageVideos, setPercentageVideos] = useState([]);
  const [randomVideos, setRandomVideos] = useState([]);
  const [rounds, setRounds] = useState([]);


  const handleAppealedVideos = () => {
    setVideoType("appeal");
  };

  const handleGeneralVideos = () => {
    setVideoType("general");
  };

  const getRoundAndFilterableVideos = () => {
    axios
      .get(
        `/api/jury/audition/VideoAssessmentAsMainGroupWithRound/${event?.id}/${activeRound}/${videoType}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setEvent(res.data.audition);
          setAuditionRoundInfo(res.data.auditionRoundInfo);
          setPercentageVideos(res.data.percentageVideos);
          setRandomVideos(res.data.randomVideos);

          console.log(res.data)
        }
      });
  };

  const fetchAuditionDetails = () => {

    axios.get(`/api/jury/audition/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data?.event);
        setActiveRound(res.data?.event?.active_round_info_id);
        setRounds(res.data.event?.audition_round);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getRoundAndFilterableVideos();
  }, [activeRound]);
  useEffect(() => {
    getRoundAndFilterableVideos();
  }, [videoType]);

  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);
  useEffect(() => { }, [distributedVideoArray]);

  const tableHead = [
    "SL.",
    "Video",
    "Group B Mark",
    "Group C Mark",
    "My Assessment",
  ];

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <div className="container-lg">
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {rounds &&
                      rounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>

          <div className="card card-bg p-3 ">
            <img
              style={{ height: "400px" }}
              src={
                event?.banner
                  ? imageCdnUrl + event?.banner
                  : Banner
              }
              className="img-fluid border-warning rounded-3  w-100"
              alt=""
            />
             
            <h5 className="BannerPs">
              Round {auditionRoundInfo?.round_num} time duration{" "}
              {moment(auditionRoundInfo?.round_start_date).format("LL")} -{" "}
              {moment(auditionRoundInfo?.round_end_date).format("LL")}
            </h5>
          </div>

          <div className="my-3">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="d-flex justify-content-center">
                <div className="col-md-md-6 small-live-session mb-3">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="first"
                      className="TabCardGold d-flex  text-decoration-none text-center me-2 fw-bold pt-3 "
                      onClick={handleGeneralVideos}
                    >
                      <h5 className="font-style fw-bold">General Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
                <div className="col-md-md-6 small-live-session">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="second"
                      className="TabCardGold py-2 fw-bold pt-3 text-decoration-none text-center "
                      onClick={handleAppealedVideos}
                    >
                      <h5 className="font-style fw-bold">Appealed Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first"></Tab.Pane>

                <Tab.Pane eventKey="second"></Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>

          <div className="row mt-3 me-2">
            <HeaderTitle
              title={`Videos from percentage filter (
                ${percentageVideos && percentageVideos.length})`}
            />


            <div className="bg-dark py-2 mx-2 mt-4">
              <TableJuryPaginateReuse
                tableHead={tableHead}
                data={percentageVideos}
                getRoundAndFilterableVideos={getRoundAndFilterableVideos}
              />

            </div>
          </div>
          <div className="row mt-3 me-2">
            <HeaderTitle
              title={` Videos from random filter (${randomVideos && randomVideos.length
                }
                )`}
            />
            <div className="bg-dark py-2 mx-2 mt-4">
              <h4 className="text-light">
                Videos from random filter ({randomVideos && randomVideos.length}
                )
              </h4>
            </div>
            <div className="bg-dark py-2 mx-2 mt-4">
              <TableJuryPaginateReuse
                tableHead={tableHead}
                data={randomVideos}
                getRoundAndFilterableVideos={getRoundAndFilterableVideos}
              />

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoAssessmentAsPrimaryGroup;
